module.exports = __webpack_public_path__ + "img/hertwx.437f4459.png";